import Translator from '../../classes/Translator/Translator';
import Session from '../../classes/Session/Session';
import { useHistory } from 'react-router-dom';
import { ChildProjectsService } from './ChildProjectsService.module';
import AwaiService from '../awai/AwaiService.service';

const ChildProjectsListLogic = () => {
  const { translator } = Translator();
  const history = useHistory();
  const hasSession = new Session({}).hasSession();
  const { getUserProperties } = ChildProjectsService();
  const { getDmrv } = AwaiService();

  const goToDmrv = async (e, owner) => {
    e.preventDefault();
    if (!hasSession) {
      history.push('/login');
      return;
    }
    try {
      const { resources } = await getUserProperties(owner);
      if (resources && resources.length > 0) {
        await getDmrv(resources[0]._id);
      }
      history.push('/dmrv', { properties: resources });
    } catch (err) {
      console.error('Error:', err);
      history.push('/dmrv', { properties: [] });
    }
  };

  return {
    translator,
    goToDmrv,
  };
};

export default ChildProjectsListLogic;
